module.exports = __webpack_public_path__ + "img/odontologa.74c657f5.svg";